module.exports = __webpack_public_path__ + "static/media/arrow_back.0ba26408.svg";